import fetchHandler from './Handler';

export const getSingleCategorySubproducts = async (data: any) => {
	try {
		const response = await fetchHandler({
			method: 'GET',
			endpoint: `/user/subcategory/category/${data}`,
		});
		return response;
	} catch (error) {
		console.error('Unexpected error:', error);
	}
};

export const createQuotation = async (data: any) => {
	try {
		const response = await fetchHandler({
			method: 'POST',
			endpoint: '/user/quotation',
			data,
		});
		return response;
	} catch (error) {
		console.error('Unexpected error:', error);
	}
};
